import isValidI18nKey from 'I18n/utils/isValidI18nKey';
export const doesCarouselTitleExist = (base, index) => {
  return isValidI18nKey(`${base}_${index}`);
};
export const getCarouselTitle = (base, index) => {
  return `${base}_${index}`;
};